import { render, staticRenderFns } from "./SystemHealthTable.vue?vue&type=template&id=0bd5f343"
import script from "./SystemHealthTable.vue?vue&type=script&lang=js"
export * from "./SystemHealthTable.vue?vue&type=script&lang=js"
import style0 from "./SystemHealthTable.vue?vue&type=style&index=0&id=0bd5f343&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports